import { ErrorBoundary } from '@sentry/react';
import { FC, Suspense } from 'react';

import { SettingsPageFrame } from '@eluve/blocks';
import { LoadingIndicator } from '@eluve/components';
import { useTranslation } from '@eluve/i18n';

import { UsersList } from './UsersList';

export const UsersPage: FC<{}> = () => {
  const { t } = useTranslation();

  return (
    <SettingsPageFrame size="wide" title={t('tenantAdmin.users.membersTitle')}>
      <ErrorBoundary
        fallback={<div>{t('tenantAdmin.common.thereWasAnError')}</div>}
      >
        <Suspense fallback={<LoadingIndicator size="xl" />}>
          <UsersList />
        </Suspense>
      </ErrorBoundary>
    </SettingsPageFrame>
  );
};
